




























import { Component, Vue } from 'vue-property-decorator';
import TicketService from "@/services/TicketService";
import AuthActions from "@/store/actions/auth";
import AuthService from "@/services/AuthService";
import axios from "axios";

@Component({
  components: {
  },
})
export default class Home extends Vue {

  private holdTicketCount:number = 0;
  private wipTicketCount:number = 0;

  mounted() {
    TicketService.countHoldTickets().then((response) => {
      this.holdTicketCount = response.data;
    }).catch((error) =>{
      alert("error " + error)
    });

    TicketService.countWipTickets().then((response)=> {
      this.wipTicketCount = response.data;
    }).catch((error) =>{
      alert("error " + error)
    });
  }
  logout(){
    this.$store.dispatch(AuthActions.AUTH_LOGOUT).then(() => this.$router.push('/login'));
    localStorage.removeItem("holdTicket");
  }

}
